import React from 'react'

export const PayrollDash=(props)=> {
    return (
        <div>

            <iframe src="https://lookerstudio.google.com/embed/reporting/f59429c7-302c-474c-bc7d-fc1358333fe4/page/pWmV"
                    style={{border:0}}
                    allowFullScreen title="Example Website"
                    width="1150"
                    height="900"
                    sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin
                     allow-popups allow-popups-to-escape-sandbox"></iframe>

        </div>
    )
}

